import { render, staticRenderFns } from "./studentlayout.vue?vue&type=template&id=0ba28e6a"
import script from "./studentlayout.vue?vue&type=script&lang=js"
export * from "./studentlayout.vue?vue&type=script&lang=js"
import style0 from "./studentlayout.vue?vue&type=style&index=0&id=0ba28e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports